import { render, staticRenderFns } from "./AboutModel.vue?vue&type=template&id=972ee36a&scoped=true"
import script from "./AboutModel.vue?vue&type=script&lang=js"
export * from "./AboutModel.vue?vue&type=script&lang=js"
import style0 from "./AboutModel.vue?vue&type=style&index=0&id=972ee36a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972ee36a",
  null
  
)

export default component.exports